import { createContext } from "react";

import type { ScoutConversationController } from "./scoutConversationController";

export const ScoutConversationControllerContext = createContext<ScoutConversationController | null>(
  null
);
